import VueRouter from 'vue-router'
import guard from '@/routes/guard'
import bus from '@/services/bus'
import {writeHistory} from '@/plugins/router-history'
import routes from '@/routes/routes'

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active'
})

// global guard
// router.beforeEach(async (to, from, next) => {
//   await guard(to, from, next)
//   bus.$emit('pathChanged')
// })
// router.afterEach(writeHistory)

export default router